import { GlobalState } from "../../utils/types";

export const clientDetailSelector = (state: GlobalState) => state.client.clientDetail;
export const clientStatusSelector = (state: GlobalState) => state.client.status;
export const clientFilesSelector = (state: GlobalState) => state.client.clientFileList;
export const clientSnapshotSelelctor = (state: GlobalState) => state.client.snapshot;
